import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';

import Swal from 'sweetalert2';



const RegistrarActas = () => {

    const { fichaGrupo: fichaGrupoURL } = useParams();
    const { actaId } = useParams();
    const navigate = useNavigate(); // Para redirigir

    useEffect(() => {
        if (fichaGrupoURL) {
            setFichaGrupo(fichaGrupoURL); // ← Solo se ejecuta una vez para inicializar
        }
    }, [fichaGrupoURL]);


    const [fichaGrupo, setFichaGrupo] = useState('');
    const [grupoObjectId, setGrupoObjectId] = useState('');

    const [nombreComiteReunion, setNombreComiteReunion] = useState('');
    const [ciudad, setCiudad] = useState('');
    const [fecha, setFecha] = useState('');
    const [horaInicio, setHoraInicio] = useState('');
    const [horaFin, setHoraFin] = useState('');
    const [lugarEnlace, setLugarEnlace] = useState('');
    const [direccionRegionalCentro, setDireccionRegionalCentro] = useState('');

    const [agenda, setAgenda] = useState(['']);
    const [objetivos, setObjetivos] = useState(['']);
    const [desarrollo, setDesarrollo] = useState(['']);
    const [conclusiones, setConclusiones] = useState(['']);

    const [compromisos, setCompromisos] = useState([
        { actividad: '', fecha: '', responsable: '' }
    ]);

    const [asistentes, setAsistentes] = useState([
        { nombre: '', dependenciaEmpresa: '', aprueba: '', observacion: '' }
    ]);

    const [edit, setEdit] = useState(false);

    useEffect(() => {
        setEdit(!!actaId);
    }, [actaId]);

    //---------------------------------------------------------------------------

    useEffect(() => {
        const fetchActa = async () => {
            try {
                if (!actaId) return;

                const response = await axios.get(`/api/grupos/actas/listid/${actaId}`);
                const data = response.data.acta;

                setFichaGrupo(data.fichaGrupo || '');
                setNombreComiteReunion(data.nombreComiteReunion || '');
                setCiudad(data.ciudad || '');
                setFecha(data.fecha || '');
                setHoraInicio(data.horaInicio || '');
                setHoraFin(data.horaFin || '');
                setLugarEnlace(data.lugarEnlace || '');
                setDireccionRegionalCentro(data.direccionRegionalCentro || '');
                setAgenda(data.agenda || '');
                setObjetivos(data.objetivos || '');
                setDesarrollo(data.desarrollo || '');
                setConclusiones(data.conclusiones || '');
                setCompromisos(data.compromisos || '');
                setAsistentes(data.asistentes || []);
            } catch (error) {
                console.error('Error al cargar el acta:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudo cargar el acta.',
                });
            }
        };

        fetchActa();
    }, [actaId]);


    // -------------------------------------------------------------------------

    const cleanData = () => {
        setFichaGrupo('');
        setGrupoObjectId('');

        setNombreComiteReunion('');
        setCiudad('');
        setFecha('');
        setHoraInicio('');
        setHoraFin('');
        setLugarEnlace('');
        setDireccionRegionalCentro('');

        setAgenda(['']);
        setObjetivos(['']);
        setDesarrollo(['']);
        setConclusiones(['']);

        setCompromisos([
            {
                actividad: '',
                fecha: '',
                responsable: ''
            }
        ]);

        setAsistentes([
            {
                nombre: '',
                dependenciaEmpresa: '',
                aprueba: '',
                observacion: ''
            }
        ]);
    };

    //-------------------------------------------------------------------------

    const saveActa = async () => {
        try {
            const newActa = {
                fichaGrupo,
                grupoObjectId,
                nombreComiteReunion,
                ciudad,
                fecha,
                horaInicio,
                horaFin,
                lugarEnlace,
                direccionRegionalCentro,
                agenda,
                objetivos,
                desarrollo,
                conclusiones,
                compromisos,
                asistentes,
            };

            await axios.post('/api/grupos/actas/add', newActa);

            cleanData();

            Swal.fire({
                icon: 'success',
                title: '¡Acta registrada con éxito!',
                showConfirmButton: false,
                timer: 1500,
            });
        } catch (error) {
            if (error.response?.data?.message) {
                return Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: error.response.data.message,
                });
            }
            console.error('Error en saveActa:', error.message);
        }
    };

    //--------------------------------------------------------------------------

    const updateActa = async () => {
        try {
            if (!actaId) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'El ID del acta no está definido.',
                });
                return;
            }

            // Crear el objeto que enviarás al backend
            const updatedActa = {
                fichaGrupo,
                nombreComiteReunion,
                ciudad,
                fecha,
                horaInicio,
                horaFin,
                lugarEnlace,
                direccionRegionalCentro,
                agenda,          // array
                objetivos,
                desarrollo,
                conclusiones,
                compromisos,
                asistentes,
            };

            // Petición PUT al backend
            const { data } = await axios.put(`/api/grupos/actas/update/${actaId}`, updatedActa);

            // Actualización de estados (si es necesario)
            setAgenda(updatedActa.agenda || []);
            setObjetivos(updatedActa.objetivos || []);
            setDesarrollo(updatedActa.desarrollo || []);
            setConclusiones(updatedActa.conclusiones || []);
            setCompromisos(updatedActa.compromisos || []);
            setAsistentes(updatedActa.asistentes || []);

            // Otros campos simples
            setFichaGrupo(updatedActa.fichaGrupo || '');
            setNombreComiteReunion(updatedActa.nombreComiteReunion || '');
            setCiudad(updatedActa.ciudad || '');
            setFecha(updatedActa.fecha || '');
            setHoraInicio(updatedActa.horaInicio || '');
            setHoraFin(updatedActa.horaFin || '');
            setLugarEnlace(updatedActa.lugarEnlace || '');
            setDireccionRegionalCentro(updatedActa.direccionRegionalCentro || '');

            // Puedes limpiar datos si tienes un `cleanData()`
            // cleanData();

            Swal.fire({
                icon: 'success',
                title: data.mensaje || 'Acta actualizada correctamente',
                showConfirmButton: false,
                timer: 1500,
            }).then(() => navigate(`/institucional/grupos/actas/listaractas/${fichaGrupo}`));

        } catch (error) {
            console.error('❌ Error en updateActa:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.response?.data?.mensaje || 'Error al actualizar el acta',
            });
        }
    };

    //--------------------------------------------------------------------------

    const actions = async (e) => {
        e.preventDefault();
        edit ? updateActa() : saveActa();
    }

    //--------------------------------------------------------------------------

    const handleAgendaChange = (index, value) => {
        const newAgenda = [...agenda];
        newAgenda[index] = value;
        setAgenda(newAgenda);
    };

    const handleAddAgenda = () => {
        setAgenda([...agenda, '']);
    };

    const handleRemoveAgenda = (index) => {
        const newAgenda = [...agenda];
        newAgenda.splice(index, 1);
        setAgenda(newAgenda);
    };

    //---------------------------------------------------------------------------

    const handleObjetivoChange = (index, value) => {
        const nuevos = [...objetivos];
        nuevos[index] = value;
        setObjetivos(nuevos);
    };

    const handleAddObjetivo = () => {
        setObjetivos([...objetivos, '']);
    };

    const handleRemoveObjetivo = (index) => {
        const nuevos = [...objetivos];
        nuevos.splice(index, 1);
        setObjetivos(nuevos);
    };

    //--------------------------------------------------------------------------

    const handleDesarrolloChange = (index, value) => {
        const nuevos = [...desarrollo];
        nuevos[index] = value;
        setDesarrollo(nuevos);
    };

    const handleAddDesarrollo = () => {
        setDesarrollo([...desarrollo, '']);
    };

    const handleRemoveDesarrollo = (index) => {
        const nuevos = [...desarrollo];
        nuevos.splice(index, 1);
        setDesarrollo(nuevos);
    };

    //-------------------------------------------------------------------------

    const handleConclusionChange = (index, value) => {
        const nuevas = [...conclusiones];
        nuevas[index] = value;
        setConclusiones(nuevas);
    };

    const handleAddConclusion = () => {
        setConclusiones([...conclusiones, '']);
    };

    const handleRemoveConclusion = (index) => {
        const nuevas = [...conclusiones];
        nuevas.splice(index, 1);
        setConclusiones(nuevas);
    };

    //--------------------------------------------------------------------------

    const handleCompromisoChange = (index, campo, valor) => {
        const nuevos = [...compromisos];
        nuevos[index][campo] = valor;
        setCompromisos(nuevos);
    };

    const handleAddCompromiso = () => {
        setCompromisos([...compromisos, { actividad: '', fecha: '', responsable: '' }]);
    };

    const handleRemoveCompromiso = (index) => {
        const nuevos = [...compromisos];
        nuevos.splice(index, 1);
        setCompromisos(nuevos);
    };

    //-------------------------------------------------------------------------

    const handleAsistenteChange = (index, campo, valor) => {
        const nuevos = [...asistentes];
        nuevos[index][campo] = valor;
        setAsistentes(nuevos);
    };

    const handleAddAsistente = () => {
        setAsistentes([...asistentes, { nombre: '', dependenciaEmpresa: '', aprueba: '', observacion: '' }]);
    };

    const handleRemoveAsistente = (index) => {
        const nuevos = [...asistentes];
        nuevos.splice(index, 1);
        setAsistentes(nuevos);
    };



    return (
        <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-2 mb-5 ">
            < div className='container-fluid mt-3' >
                <h1>Registrar Acta</h1>
            </div>

            <div className='mb-5'>

                <form onSubmit={actions}>
                      <div className="container">
                        <div >
                            <div className="row">
                                {/* Datos básicos del acta */}
                                <div className="col-12 col-md-2 mt-2">
                                    <label className="form-label">Ficha del Grupo</label>
                                    <input
                                        type="number"
                                        name="fichaGrupo"
                                        className="form-control"
                                        placeholder="Ej. 2711519"
                                        value={fichaGrupo}
                                        onChange={(e) => setFichaGrupo(e.target.value)}
                                    />
                                </div>

                                <div className="col-12 col-md-4 mt-2">
                                    <label className="form-label">Nombre del Comité o Reunión</label>
                                    <select
                                        name="nombreComiteReunion"
                                        className="form-select"
                                        required
                                        value={nombreComiteReunion}
                                        onChange={(e) => setNombreComiteReunion(e.target.value)}
                                    >
                                        <option value="">Seleccione un tipo de acta</option>
                                        <option value="Inicio de Formación">Inicio de Formación</option>
                                        <option value="Seguimiento a la Formación">Seguimiento a la Formación</option>
                                        <option value="Evaluación y Seguimiento">Evaluación y Seguimiento</option>
                                        <option value="Socialización Etapa Productiva">Socialización Etapa Productiva</option>
                                        <option value="Socialización Proyecto Formativo">Socialización Proyecto Formativo</option>
                                        <option value="Seguimiento Individual del Aprendiz">Seguimiento Individual del Aprendiz</option>
                                        <option value="Comité Técnico del Programa">Comité Técnico del Programa</option>
                                        <option value="Cierre de Formación">Cierre de Formación</option>
                                    </select>
                                </div>

                                <div className="col-12 col-md-3 mt-2">
                                    <label className="form-label">Ciudad</label>
                                    <input
                                        type="text"
                                        name="ciudad"
                                        className="form-control"
                                        placeholder="Ej. Medellín"
                                        value={ciudad}
                                        onChange={(e) => setCiudad(e.target.value)}
                                    />
                                </div>

                                <div className="col-12 col-md-3 mt-2">
                                    <label className="form-label">Fecha</label>
                                    <input
                                        type="date"
                                        name="fecha"
                                        className="form-control"
                                        required
                                        value={fecha}
                                        onChange={(e) => setFecha(e.target.value)}
                                    />
                                </div>

                                <div className="col-12 col-md-2 mt-2">
                                    <label className="form-label">Hora Inicio</label>
                                    <input
                                        type="time"
                                        name="horaInicio"
                                        className="form-control"
                                        value={horaInicio}
                                        onChange={(e) => setHoraInicio(e.target.value)}
                                    />
                                </div>

                                <div className="col-12 col-md-2 mt-2">
                                    <label className="form-label">Hora Fin</label>
                                    <input
                                        type="time"
                                        name="horaFin"
                                        className="form-control"
                                        value={horaFin}
                                        onChange={(e) => setHoraFin(e.target.value)}
                                    />
                                </div>

                                <div className="col-12 col-md-4 mt-2">
                                    <label className="form-label">Lugar / Enlace Virtual</label>
                                    <input
                                        type="text"
                                        name="lugarEnlace"
                                        className="form-control"
                                        value={lugarEnlace}
                                        onChange={(e) => setLugarEnlace(e.target.value)}
                                    />
                                </div>

                                <div className="col-12 col-md-4 mt-2">
                                    <label className="form-label">Dirección Regional / Centro</label>
                                    <input
                                        type="text"
                                        name="direccionRegionalCentro"
                                        className="form-control"
                                        value={direccionRegionalCentro}
                                        onChange={(e) => setDireccionRegionalCentro(e.target.value)}
                                    />
                                </div>




                                <div className="col-12 mt-3 mb-3">
                                    {/* NAV TABS */}
                                    <ul className="nav nav-tabs" id="miTab" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className="nav-link active"
                                                id="agenda-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#agenda"
                                                type="button"
                                                role="tab"
                                                aria-controls="agenda"
                                                aria-selected="true"
                                            >
                                                Agenda
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className="nav-link"
                                                id="objetivos-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#objetivos"
                                                type="button"
                                                role="tab"
                                                aria-controls="objetivos"
                                                aria-selected="false"
                                            >
                                                Objetivos
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className="nav-link"
                                                id="desarrollo-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#desarrollo"
                                                type="button"
                                                role="tab"
                                                aria-controls="desarrollo"
                                                aria-selected="false"
                                            >
                                                Desarrollo
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className="nav-link"
                                                id="conclusiones-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#conclusiones"
                                                type="button"
                                                role="tab"
                                                aria-controls="conclusiones"
                                                aria-selected="false"
                                            >
                                                Conclusiones
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className="nav-link"
                                                id="compromiso-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#compromiso"
                                                type="button"
                                                role="tab"
                                                aria-controls="compromiso"
                                                aria-selected="false"
                                            >
                                                Compromiso
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className="nav-link"
                                                id="asistentes-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#asistentes"
                                                type="button"
                                                role="tab"
                                                aria-controls="asistentes"
                                                aria-selected="false"
                                            >
                                                Asistentes
                                            </button>
                                        </li>
                                    </ul>

                                    {/* TAB CONTENT */}
                                    <div className="tab-content p-3 border border-top-0" id="miTabContent">
                                        {/* TAB: AGENDA */}
                                        <div className="tab-pane fade show active" id="agenda" role="tabpanel" aria-labelledby="agenda-tab">
                                            <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between mb-2">
                                                <h5 className="mb-2 mb-md-0">Agenda</h5>
                                            </div>

                                            <div >
                                                {agenda.map((item, index) => (
                                                    <div className="row mb-3" key={index}>
                                                        <div className="col-10 col-md-11 mb-2 mb-md-0">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder={`Punto ${index + 1}`}
                                                                value={item}
                                                                onChange={(e) => handleAgendaChange(index, e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="col-2 col-md-1 d-flex align-items-center">
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger"
                                                                 style={{ width: "30px", height: "30px", padding: "0" }}
                                                                onClick={() => handleRemoveAgenda(index)}
                                                                title="Eliminar punto"
                                                            >
                                                                <i className="fa-solid fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>

                                            <div className="row mt-2">
                                                <div className="col-6 d-flex align-items-center">
                                                    <h6 className="mb-0">Agregar Punto</h6>
                                                </div>
                                                <div className="col-6 d-flex justify-content-end">
                                                    <button
                                                        type="button"
                                                        className="btn btn-success rounded-circle d-flex align-items-center justify-content-center"
                                                        style={{ width: '40px', height: '40px' }}
                                                        onClick={handleAddAgenda}
                                                        title="Agregar Agenda"
                                                    >
                                                        <i className="fa-solid fa-plus text-white"></i>
                                                    </button>
                                                </div>
                                            </div>

                                        </div>


                                        {/* TAB: OBJETIVOS */}
                                        <div className="tab-pane fade" id="objetivos" role="tabpanel" aria-labelledby="objetivos-tab">
                                            <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between mb-2">
                                                <h5 className="mb-2 mb-md-0">Objetivos</h5>
                                            </div>

                                            <div >
                                                {objetivos.map((item, index) => (
                                                    <div className="row mb-3" key={index}>
                                                        <div className="col-10 col-md-11 mb-2 mb-md-0">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder={`Objetivo ${index + 1}`}
                                                                value={item}
                                                                onChange={(e) => handleObjetivoChange(index, e.target.value)}
                                                            />
                                                        </div>
                                                       <div className="col-2 col-md-1 d-flex align-items-center">
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger"
                                                                 style={{ width: "30px", height: "30px", padding: "0" }}
                                                                onClick={() => handleRemoveObjetivo(index)}
                                                                title="Eliminar objetivo"
                                                            >
                                                                <i className="fa-solid fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>

                                            <div className="row mt-2">
                                                <div className="col-6 d-flex align-items-center">
                                                    <h6 className="mb-0">Agregar Objetivo</h6>
                                                </div>
                                                <div className="col-6 d-flex justify-content-end">
                                                    <button
                                                        type="button"
                                                        className="btn btn-success rounded-circle d-flex align-items-center justify-content-center"
                                                        style={{ width: '40px', height: '40px' }}
                                                        onClick={handleAddObjetivo}
                                                        title="Agregar Objetivo"
                                                    >
                                                        <i className="fa-solid fa-plus text-white"></i>
                                                    </button>
                                                </div>
                                            </div>

                                        </div>

                                        {/* TAB: DESARROLLO */}
                                        <div className="tab-pane fade" id="desarrollo" role="tabpanel" aria-labelledby="desarrollo-tab">
                                            <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between mb-2">
                                                <h5 className="mb-2 mb-md-0">Desarrollo</h5>
                                            </div>

                                            <div >
                                                {desarrollo.map((item, index) => (
                                                    <div className="row mb-3" key={index}>
                                                        <div className="col-10 col-md-11 mb-2 mb-md-0">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder={`Punto ${index + 1}`}
                                                                value={item}
                                                                onChange={(e) => handleDesarrolloChange(index, e.target.value)}
                                                            />
                                                        </div>
                                                       <div className="col-2 col-md-1 d-flex align-items-center">
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger"
                                                                 style={{ width: "30px", height: "30px", padding: "0" }}
                                                                onClick={() => handleRemoveDesarrollo(index)}
                                                                title="Eliminar punto"
                                                            >
                                                                <i className="fa-solid fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>

                                            <div className="row mt-2">
                                                <div className="col-6 d-flex align-items-center">
                                                    <h6 className="mb-0">Agregar Punto</h6>
                                                </div>
                                                <div className="col-6 d-flex justify-content-end">
                                                    <button
                                                        type="button"
                                                        className="btn btn-success rounded-circle d-flex align-items-center justify-content-center"
                                                        style={{ width: '40px', height: '40px' }}
                                                        onClick={handleAddDesarrollo}
                                                        title="Agregar Desarrollo"
                                                    >
                                                        <i className="fa-solid fa-plus text-white"></i>
                                                    </button>
                                                </div>
                                            </div>

                                        </div>


                                        {/* TAB: CONCLUSIONES */}
                                        <div className="tab-pane fade" id="conclusiones" role="tabpanel" aria-labelledby="conclusiones-tab">
                                            <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between mb-2">
                                                <h5 className="mb-2 mb-md-0">Conclusiones</h5>
                                            </div>

                                            <div >
                                                {conclusiones.map((item, index) => (
                                                    <div className="row mb-3" key={index}>
                                                        <div className="col-10 col-md-11 mb-2 mb-md-0">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder={`Conclusión ${index + 1}`}
                                                                value={item}
                                                                onChange={(e) => handleConclusionChange(index, e.target.value)}
                                                            />
                                                        </div>
                                                       <div className="col-2 col-md-1 d-flex align-items-center">
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger"
                                                                 style={{ width: "30px", height: "30px", padding: "0" }}
                                                                onClick={() => handleRemoveConclusion(index)}
                                                                title="Eliminar conclusión"
                                                            >
                                                                <i className="fa-solid fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>

                                            <div className="row mt-2">
                                                <div className="col-6 d-flex align-items-center">
                                                    <h6 className="mb-0">Agregar Conclusión</h6>
                                                </div>
                                                <div className="col-6 d-flex justify-content-end">
                                                    <button
                                                        type="button"
                                                        className="btn btn-success rounded-circle d-flex align-items-center justify-content-center"
                                                        style={{ width: '40px', height: '40px' }}
                                                        onClick={handleAddConclusion}
                                                        title="Agregar Conclusión"
                                                    >
                                                        <i className="fa-solid fa-plus text-white"></i>
                                                    </button>
                                                </div>
                                            </div>

                                        </div>

                                        {/* TAB: COMPROMISO */}
                                        <div className="tab-pane fade" id="compromiso" role="tabpanel" aria-labelledby="compromiso-tab">
                                            <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between mb-2">
                                                <h5 className="mb-2 mb-md-0">Compromisos</h5>
                                            </div>

                                            <div >
                                                {compromisos.map((item, index) => (
                                                    <div className="row mb-3" key={index}>
                                                        <div className="col-12 col-md-5 mb-2 mb-md-0">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Actividad"
                                                                value={item.actividad}
                                                                onChange={(e) => handleCompromisoChange(index, 'actividad', e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="col-12 col-md-3 mb-2 mb-md-0">
                                                            <input
                                                                type="date"
                                                                className="form-control"
                                                                value={item.fecha ? item.fecha.substring(0, 10) : ''}
                                                                onChange={(e) => handleCompromisoChange(index, 'fecha', e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="col-12 col-md-3 mb-2 mb-md-0">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Responsable"
                                                                value={item.responsable}
                                                                onChange={(e) => handleCompromisoChange(index, 'responsable', e.target.value)}
                                                            />
                                                        </div>
                                                       <div className="col-2 col-md-1 d-flex align-items-center">
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger"
                                                                 style={{ width: "30px", height: "30px", padding: "0" }}
                                                                onClick={() => handleRemoveCompromiso(index)}
                                                                title="Eliminar compromiso"
                                                            >
                                                                <i className="fa-solid fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>

                                            <div className="row mt-2">
                                                <div className="col-6 d-flex align-items-center">
                                                    <h6 className="mb-0">Agregar Compromiso</h6>
                                                </div>
                                                <div className="col-6 d-flex justify-content-end">
                                                    <button
                                                        type="button"
                                                        className="btn btn-success rounded-circle d-flex align-items-center justify-content-center"
                                                        style={{ width: '40px', height: '40px' }}
                                                        onClick={handleAddCompromiso}
                                                        title="Agregar Compromiso"
                                                    >
                                                        <i className="fa-solid fa-plus text-white"></i>
                                                    </button>
                                                </div>
                                            </div>

                                        </div>

                                        {/* TAB: ASISTENTES */}
                                        <div className="tab-pane fade" id="asistentes" role="tabpanel" aria-labelledby="asistentes-tab">
                                            <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between mb-2">
                                                <h5 className="mb-2 mb-md-0">Asistentes</h5>
                                            </div>

                                            <div >
                                                {asistentes.map((asistente, index) => (
                                                    <div className="row mb-3" key={index}>
                                                        <div className="col-12 col-md-3 mb-2 mb-md-0">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Nombre"
                                                                value={asistente.nombre}
                                                                onChange={(e) => handleAsistenteChange(index, 'nombre', e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="col-12 col-md-3 mb-2 mb-md-0">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Dependencia / Empresa"
                                                                value={asistente.dependenciaEmpresa}
                                                                onChange={(e) => handleAsistenteChange(index, 'dependenciaEmpresa', e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="col-12 col-md-2 mb-2 mb-md-0">
                                                            <select
                                                                className="form-control"
                                                                value={asistente.aprueba}
                                                                onChange={(e) => handleAsistenteChange(index, 'aprueba', e.target.value)}
                                                            >
                                                                <option value="">¿Aprueba?</option>
                                                                <option value="Sí">Sí</option>
                                                                <option value="No">No</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-12 col-md-3 mb-2 mb-md-0">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Observación"
                                                                value={asistente.observacion}
                                                                onChange={(e) => handleAsistenteChange(index, 'observacion', e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="col-12 col-md-1 d-flex justify-content-md-center align-items-center mt-2 mt-md-0">
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger"
                                                                 style={{ width: "30px", height: "30px", padding: "0" }}
                                                                onClick={() => handleRemoveAsistente(index)}
                                                                title="Eliminar asistente"
                                                            >
                                                                <i className="fa-solid fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>

                                            <div className="row mt-2">
                                                <div className="col-6 d-flex align-items-center">
                                                    <h6 className="mb-0">Agregar Asistente</h6>
                                                </div>
                                                <div className="col-6 d-flex justify-content-end">
                                                    <button
                                                        type="button"
                                                        className="btn btn-success rounded-circle d-flex align-items-center justify-content-center"
                                                        style={{ width: '40px', height: '40px' }}
                                                        onClick={handleAddAsistente}
                                                        title="Agregar Asistente"
                                                    >
                                                        <i className="fa-solid fa-plus text-white"></i>
                                                    </button>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="row container-fluid mt-3 mb-3">
                        <div className="col-md-12 d-flex justify-content-center">
                            <button type="submit" className="btn btn-success w-100">{actaId ? 'Actualizar' : 'Enviar'}</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>

    )
}

export default RegistrarActas
